export default {
  text_input: {
    note: {
      place_holder: 'Nota...',
    },
  },
  buttons: {
    cancel: 'Annulla',
    save: 'Salva',
  },
};
